import { trackEvent, GA_LABEL as label } from '../../../shared/utils/analytics'
import * as searchTypes from '../../actionTypes/searchTypes'
import * as parametersTypes from '../../actionTypes/parametersTypes'
import * as trackActions from './trackActions'

const { trackSelectValue, trackDeselectValue, trackActiveSort, trackError } = trackActions

const { SELECT_VALUE, DESELECT_VALUE } = searchTypes
const { CHANGE_ACTIVE_SORT } = parametersTypes

export const gaMiddleware = store => next => action => {
  try {
    switch (action.type) {
      case SELECT_VALUE:
        trackEvent(trackSelectValue(store.getState(), action, label))
        break
      case DESELECT_VALUE:
        trackEvent(trackDeselectValue(action, label))
        break
      case CHANGE_ACTIVE_SORT:
        trackEvent(trackActiveSort(store.getState(), action, label))
        break
      default:
        break
    }
    return next(action)
  } catch (error) {
    return trackEvent(trackError(error, action, label))
  }
}



// WEBPACK FOOTER //
// ./src/shared/middlewares/analytics/index.js